import {defineStore} from 'pinia'
import axios from "axios";
import * as CONFIG from 'cw-conf'

export const useCartStore = defineStore('CartStore', {
    persist: true,
    state: () => {
        return {
            count: 0,
            subtotal: 0,
            products: []
        }
    },

    actions: {
        async incrementCartItem(rowId) {
            let r = await axios
                .post(CONFIG.SERVER_AJAX_URL + '/cart/increment', {rowId: rowId});

            this.$patch({
                count: r.data.count,
                subtotal: r.data.subtotal
            })

            return r.data;
        },

        async decrementCartItem(rowId) {
            let r = await axios
                .post(CONFIG.SERVER_AJAX_URL + '/cart/decrement', {rowId: rowId});

            this.$patch({
                count: r.data.count,
                subtotal: r.data.subtotal
            })

            return r.data;
        },

        async removeFromCart(rowId) {
            let r = await axios
                .post(CONFIG.SERVER_AJAX_URL + '/cart/remove', {rowId: rowId});

                this.count = r.data.count
                this.subtotal = r.data.subtotal
                this.products = r.data.products
        },

        async addToCart(productId) {
            let r = await axios
                .post(CONFIG.SERVER_AJAX_URL + '/cart/add', {productId: productId});

            this.$patch({
                count: r.data.count
            })
        },

        setSubtotal(value) {
            this.subtotal = value
        },

        setProducts(value) {
            this.products = value
        },

        setCount(value) {
            this.count = value
        }
    }
})
